export default __webpack_public_path__ + "static/media/tola-coo.705bcf83.jpg";